import { graphql } from '@api/mesa'

graphql(`
  fragment SettingsItems on CategorySettingsTypes {
    push_notification
    email
  }
`)

export const GET_NOTIFICATION_SETTINGS = graphql(`
  query GetNotificationSettings {
    getNotificationSettings {
      settings {
        card {
          pending_transactions {
            ...SettingsItems
          }
          approved_transactions {
            ...SettingsItems
          }
          declined_transactions {
            ...SettingsItems
          }
          payment_received {
            ...SettingsItems
          }
          payment_failures {
            ...SettingsItems
          }
        }
        marketing {
          new_benefits {
            ...SettingsItems
          }
          new_rewards {
            ...SettingsItems
          }
          mesa_mortgage {
            ...SettingsItems
          }
        }
        announcements {
          new_app_features {
            ...SettingsItems
          }
          milestones {
            ...SettingsItems
          }
        }
      }
    }
  }
`)

export const GET_USER_NOTIFICATIONS = graphql(`
  query GetUserNotifications(
    $cursor: UserNotificationCursorInput
    $pushNotificationStatus: UserPushNotificationStatus
  ) {
    getUserNotifications(cursor: $cursor, pushNotificationStatus: $pushNotificationStatus) {
      __typename
      notifications {
        __typename
        id
        title
        body
        createdAt
        pushNotificationStatus
        deepLinkPath
      }
    }
  }
`)
